import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from './util';
const Tiny = (_jsx("svg", Object.assign({ viewBox: "0 0 20 20" }, { children: _jsx("path", { d: "M10,13.00025 C9.86036998,13.00025 9.72073997,12.95125 9.61383573,12.85425 L4.1595382,7.85425 C3.9468206,7.65825 3.9468206,7.34225 4.1595382,7.14625 C4.37334667,6.95125 4.71805827,6.95125 4.93186673,7.14625 L10,11.79325 L15.0681333,7.14625 C15.2819417,6.95125 15.6266533,6.95125 15.8404618,7.14625 C16.0531794,7.34225 16.0531794,7.65825 15.8404618,7.85425 L10.3861643,12.85425 C10.27926,12.95125 10.13963,13.00025 10,13.00025", fill: "currentColor" }, void 0) }), void 0));
export const variants = {
    tiny: Tiny,
    default: Tiny,
};
export default withVariants(variants);
